module.exports = __webpack_public_path__ + "static/media/away.f76a7ec5.svg";